import { render, staticRenderFns } from "./Cascader-panel.vue?vue&type=template&id=82219f2c&scoped=true"
import script from "./Cascader-panel.vue?vue&type=script&lang=js"
export * from "./Cascader-panel.vue?vue&type=script&lang=js"
import style0 from "./Cascader-panel.vue?vue&type=style&index=0&id=82219f2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82219f2c",
  null
  
)

export default component.exports